<app-feature-hero
    variant="itsm"
    title="Utility Management Software"
    description="Manage your utilities like a pro with our powerful utility management solution."
    image=""
    imageAlt=""
></app-feature-hero>

<section class="container">
  <div class="row align-items-center section-spacing">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title">What is Utility Management Software?</h2>
        <p class="section-paragraph">
          Utility Management Software is a solution that helps organizations manage their utility
          usage and costs. This type of software can track utility usage, generate reports, and
          provide analysis to help organizations optimize their utility usage and costs. The
          software has the ability to track and manage utility bills and payments; set up budget and
          consumption alerts, and generate reports.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/faq-illustration.svg"
        class="w-90"
        alt="Server management and application management"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div class="row reverse-col">
    <div
      class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex align-items-end justify-content-center"
    >
      <img
        src="/assets/img/feature-pages/infraon-itsm/utility-management/network-switch-mngmnt-2.webp"
        style="transform: rotateY(180deg)"
        class="w-60"
        alt="What does a Utility Management Software do?"
      />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <h2 class="section-title mb-0">
        What does a Utility Management <br />
        Software do?
      </h2>
      <p class="section-paragraph mt-5 mb-2 pr-3">
        Infraon's utility management software is used to track, manage, and optimize utility usage
        and expenditure. The software provides a centralized platform for tracking utility data,
        analyzing trends, and identifying cost-saving opportunities. It can also be used to manage
        and monitor utility services, such as water, gas, and electricity, by generating a report on
        consumption, helping better planning and budgeting.
      </p>
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div class="row mx-0">
    <h2 class="section-title mb-0">Key benefits of Utility Management Software</h2>
  </div>

  <div class="row mx-0 justify-content-between">
    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12 mb-5">
      <img
        src="/assets/img/feature-pages/infraon-itsm/utility-management/box-beige-01.svg"
        alt="Box icon in beige color"
      />
      <h3 class="section-title-s text-start" style="margin: 34px 0 12px 0">
        Save energy and reduce waste
      </h3>
      <p class="section-paragraph">
        Infraon's Utility Management Software provides a comprehensive view of an organization's
        energy usage, cost, and carbon footprint. It allows organizations to make informed decisions
        on how to reduce their energy consumption. In addition, it can help organizations track and
        report on their energy savings and progress towards sustainability goals.
      </p>
    </div>
    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/utility-management/monitor-beige-01.svg"
        alt="monitor icon colored beige"
      />
      <h3 class="section-title-s text-start" style="margin: 34px 0 12px 0">
        Track and manage utilities
      </h3>
      <p class="section-paragraph">
        Use Infraon's Utility Management Software to help optimize their usage, control costs, and
        improve efficiency. Additionally, you can ensure compliance with regulations. You can avoid
        energy wastage by identifying which utility is being underutilized or not used optimally.
        You can save energy and money by monitoring the consumption.
      </p>
    </div>
    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12 mb-5">
      <img
        src="/assets/img/feature-pages/infraon-itsm/utility-management/medal-beige.svg"
        alt="medal icon colored beige"
      />
      <h3 class="section-title-s text-start" style="margin: 34px 0 12px 0">
        Streamline utility management
      </h3>
      <p class="section-paragraph">
        You can streamline utility management by using Utility Management Software. It can help
        automate many of the tasks associated with utility management, such as billing, payments,
        and customer service. It can save the utility company time and money and make the process of
        tracking and managing utilities more efficient.
      </p>
    </div>
    <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-xs-12 mb-5">
      <img
        src="/assets/img/feature-pages/infraon-itsm/utility-management/user-beige-01.svg"
        alt="user icon colored beige"
      />
      <h3 class="section-title-s text-start" style="margin: 34px 0 12px 0">
        Forecast energy consumption
      </h3>
      <p class="section-paragraph">
        Infraon's Utility Management Software can help organizations save money on their utility
        bills. You can negotiate better terms with utility providers and avoid overpaying by
        accurately forecasting consumption. Also, forecasting consumption can help avoid peak demand
        charges and manage energy use more efficiently.
      </p>
    </div>
  </div>
</section>

<section class="bg-grey section-spacing key-benifit">
  <div class="container">
    <div class="row mx-0">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <h2 class="section-title pb-4">Using Infraon's Utility Management Software</h2>
        <a
          class="primary-buttons cta-buttons rounded-full"
          [routerLink]="['/registration']"
          [queryParams]="{ type: 'trial' }"
          >Start Your Free Trial</a
        >
      </div>
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-itsm/utility-management/config-new-feature.svg"
              alt="Improves Asset Management"
            />
            <p class="section-title-s text-start py-3">Track utilities</p>
            <p class="section-paragraph-s text-start">
              Infraon's Utility Management Software includes tracking utilities to help
              organizations keep track of their utility usage and costs. Tracking utilities allow
              organizations to view their usage and cost data over time, helping them identify
              trends and cost savings opportunities. It also has alerts for managing utility
              contracts, such as contract renewal reminders and alerts for changes in utility rates.
            </p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-itsm/utility-management/clock-small.svg"
              alt="Clock icon"
            />
            <p class="section-title-s text-start py-3">Prioritize work orders</p>
            <p class="section-paragraph-s text-start">
              Infraon's Utility Management Software ensures that the most critical tasks are
              completed first. This ensures that the utility company is able to provide the best
              possible service to its customers. Whether a small maintenance task or long, the
              checklist can be shared across the team so they can work efficiently in order of
              priority and update the status simultaneously, with total visibility.
            </p>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-itsm/utility-management/alert-new-feature.svg"
              alt="Alert Icon 2"
            />
            <p class="section-title-s text-start py-3">Alerts and notifications</p>
            <p class="section-paragraph-s text-start">
              Infraon's Utility Management Software enables alerts and notifications that can be set
              for instant communication to users. Alerts can be automatically sent to notify users
              of critical information. These alerts will help users know that allotted units have
              been consumed and overconsumption can be avoided.
            </p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="/assets/img/feature-pages/infraon-itsm/utility-management/doc-new-feature.svg"
              alt="document icon 2"
            />
            <p class="section-title-s text-start py-3">Reporting and analytics</p>
            <p class="section-paragraph-s text-start">
              Infraon's Utility Management Software offers tools for monitoring and analyzing energy
              usage and for managing energy-related equipment and appliances. The software's
              reporting and analytics features allow users to track their energy usage over time,
              identify trends, and identify opportunities for energy savings.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-spacing primary-bg trial-now">
  <div class="container">
    <h2 class="section-title text-center text-white">
      <span class="text-lowercase">How about a free trial with NO credit card required?</span>
    </h2>

    <div class="d-flex justify-content-center">
      <a routerLink="/itsm-tool/prices/itsm-pricing" class="secondary-button bg-white">Start now</a>
    </div>
  </div>
</section>

<section class="section-spacing bg-grey">
  <div class="container">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <a routerLink="/it-asset-management/features/it-assets-management-solutions">
          <div class="backlink-container bg-white px-5 py-4 h-100">
            <p class="section-title-s text-start">IT asset management</p>
            <p class="section-paragraph-s text-start">
              Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to
              optimize your IT asset usage. Make smart purchasing...
            </p>
            <p class="primary-color mb-0">Know more</p>
          </div>
        </a>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <a routerLink="/it-asset-management/features/software-assets-management-solutions">
          <div class="backlink-container bg-white px-5 py-4 h-100">
            <p class="section-title-s text-start">Software asset management</p>
            <p class="section-paragraph-s text-start">
              Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to
              optimize your IT asset usage. Make smart purchasing...
            </p>
            <p class="primary-color mb-0">Know more</p>
          </div>
        </a>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <a routerLink="/it-asset-management/features/software-license-management">
          <div class="backlink-container bg-white px-5 py-4 h-100">
            <p class="section-title-s text-start">Software Licensing management</p>
            <p class="section-paragraph-s text-start">
              Infraon Assets helps you manage the lifecycles of fixed assets like PCs, laptops,
              furniture, storage devices, etc., with a 360-degree view...
            </p>
            <p class="primary-color mb-0">Know more</p>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>
